export default "__VITE_ASSET__B_OBU6a1__"